export enum PageTab {
  Users = 'users',
  Entities = 'entities',
  Invitations = 'invitations',
  OnboardingTemplates = 'onboarding-templates',
  FirmOnboarding = 'firm-onboarding',
  SystemNotifications = 'system-notifications',
  AssistantFeedback = 'assistant-feedback',
  EmailReminders = 'email-reminders',
  Emails = 'emails',
}
